import { useNavigate } from 'react-router-dom';
import { Button, Result } from 'antd';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <Result
      status="404"
      title="۴۰۴"
      subTitle="صفحه‌ای که دنبال آن هستید یافت نشد."
      extra={
        <Button type="primary" onClick={() => navigate('/', { replace: true })}>
          بازگشت به خانه
        </Button>
      }
    />
  );
}
